import { render } from "./TeamMemberCard.vue?vue&type=template&id=07b47b9a&scoped=true&ts=true"
import script from "./TeamMemberCard.vue?vue&type=script&lang=ts"
export * from "./TeamMemberCard.vue?vue&type=script&lang=ts"

import "./TeamMemberCard.vue?vue&type=style&index=0&id=07b47b9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b47b9a"]])

export default __exports__